module.exports = __webpack_public_path__ + "static/antd-61fe3c2be9099eb4db6b8e6a177761f7.png";